import { api } from './http'
import { and, or, searchParam } from './filters'

// Contratos VERIFICADOS EN VIVO contra el backend MT (2026-06-25) salvo donde se indique.

// --- Typeahead de clientes ---
// VIVO: GET /clientes?view=BaseList&search=<JSON or(...)>  -> HTTP 200, lista rica.
// El front Angular dispara recién con searchValue.length >= 3 (form.js:7891).
// Sin `view=BaseList` los items vienen "finos" (solo {id}); CON view traen nombre,
// numero, sucursales, tipoOperacion, etc. (por eso antes parecía que el filtro fallaba).
// Estructura del filtro = filterFactory.or de varios and (cada uno + activo==true).
export function buscarClientes(searchValue, { view = 'BaseList' } = {}) {
  if (!searchValue || searchValue.length < 3) return Promise.resolve([])
  const v = searchValue
  const filtro = or([
    and([{ path: 'nombre', like: v }, { path: 'activo', equals: true }]),
    and([{ path: 'nombreFantasia', like: v }, { path: 'activo', equals: true }]),
    and([{ path: 'codigo', like: v }, { path: 'activo', equals: true }]),
    and([{ path: 'numero', like: v }, { path: 'activo', equals: true }]),
    and([{ path: 'direccion', like: v }, { path: 'activo', equals: true }]),
    and([{ path: 'ciudad.descripcion', like: v }, { path: 'activo', equals: true }]),
  ])
  return api.get('/clientes', { params: searchParam(filtro, { view }) }).then((r) => r.data)
}

// --- Cliente default para Facturación Ágil ---
// VIVO: GET /clientes?view=BaseList&search=<and(activo==true, factAgilDefault==true)> -> 1 item rico.
// IMPORTANTE: el filtro NO es ?factAgilDefault=true (ese flag NO filtra); va dentro de `search`.
// Con view=BaseList el item ya trae sucursales[] y tipoOperacion (no hace falta fetch por id).
export function getClienteDefaultAgil() {
  const filtro = and([
    { path: 'activo', equals: true },
    { path: 'factAgilDefault', equals: true },
  ])
  return api
    .get('/clientes', { params: searchParam(filtro, { view: 'BaseList' }) })
    .then((r) => r.data)
    .then((list) => (Array.isArray(list) ? list[0] || null : list))
}

// --- Detalle por id ---
// VIVO: GET /clientes/{id}?view=BaseList -> objeto completo con sucursales[] ricas + tipoOperacion.
// Usar tras seleccionar un cliente en el typeahead si se necesitan sus sucursales/tipoOperacion.
export function getCliente(id, view = 'BaseList') {
  return api.get(`/clientes/${id}`, { params: { view } }).then((r) => r.data)
}

// --- Consulta RUC (SET) ---
// VIVO: GET /clientes/consultaruc/?numeroDocumento=... -> { codigoRespuesta, respuesta, numeroDocumento, razonSocial, ... }
// codigoRespuesta "1" = error/no encontrado; razonSocial presente = ok.
export function consultaRuc(numeroDocumento) {
  return api.get('/clientes/consultaruc/', { params: { numeroDocumento } }).then((r) => r.data)
}

// POST /clientes (alta rápida).
// NOTA: shape del payload de alta NO verificado con un POST real (read-only). El front
// Angular envía el objeto cliente completo. // PENDIENTE: validar con un POST real.
export function crearCliente(payload) {
  return api.post('/clientes', payload).then((r) => r.data)
}
